import { render, staticRenderFns } from "./HooksIcon.vue?vue&type=template&id=188d36c8&scoped=true"
import script from "./HooksIcon.vue?vue&type=script&lang=js"
export * from "./HooksIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188d36c8",
  null
  
)

export default component.exports